import React from 'react';
import Home from './Screens/Home';

const App = () => {
  return (
    <div>
      <Home></Home>
    </div>
  );
};

export default App;